// Random - dice, coin, number, list picker, UUID.
import { el, btn, input, ta, wrap, copy } from "./ui.js";

const named = (elm, label) => { elm.setAttribute("aria-label", label); return elm; };
const liveOut = () => { const o = el("div", "rv-rand-out", "-"); o.setAttribute("role", "status"); return o; };

const rnd = (n) => { const a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] % n; };

export function random(root) {
	const s = wrap(root); s.classList.add("rv-rand");

	// dice
	const sides = named(input("number", { value: "6", min: "2", max: "1000" }), "Sides per die"); sides.classList.add("rv-rand-num");
	const count = named(input("number", { value: "1", min: "1", max: "20" }), "Number of dice"); count.classList.add("rv-rand-num");
	const diceOut = liveOut();
	const diceRow = el("div", "rv-trow");
	diceRow.append(count, el("span", null, "d"), sides, btn("Roll", () => {
		const n = Math.min(20, Math.max(1, parseInt(count.value) || 1)), f = Math.max(2, parseInt(sides.value) || 6);
		const rolls = []; for (let i = 0; i < n; i++) rolls.push(rnd(f) + 1);
		diceOut.textContent = rolls.join("  ") + (n > 1 ? "   = " + rolls.reduce((a, b) => a + b, 0) : "");
	}, "rv-tbtn rv-tbtn-accent"));

	// coin
	const coinOut = liveOut();
	const coinRow = el("div", "rv-trow"); coinRow.append(btn("Flip coin", () => { coinOut.textContent = rnd(2) ? "Heads" : "Tails"; }, "rv-tbtn rv-tbtn-accent"));

	// number
	const min = named(input("number", { value: "1" }), "Lowest number"); min.classList.add("rv-rand-num");
	const max = named(input("number", { value: "100" }), "Highest number"); max.classList.add("rv-rand-num");
	const numOut = liveOut();
	const numRow = el("div", "rv-trow");
	numRow.append(min, el("span", null, "to"), max, btn("Pick", () => {
		let a = parseInt(min.value) || 0, b = parseInt(max.value) || 0; if (a > b) [a, b] = [b, a];
		numOut.textContent = String(a + rnd(b - a + 1));
	}, "rv-tbtn rv-tbtn-accent"));

	// picker
	const listInput = named(ta({ placeholder: "One item per line…" }), "Items to pick from, one per line"); listInput.classList.add("rv-rand-list");
	const pickOut = liveOut();
	const pickRow = el("div", "rv-trow");
	pickRow.append(btn("Pick one", () => { const arr = listInput.value.split(/\r?\n/).map((l) => l.trim()).filter(Boolean); pickOut.textContent = arr.length ? arr[rnd(arr.length)] : "-"; }, "rv-tbtn rv-tbtn-accent"),
		btn("Shuffle", () => { const arr = listInput.value.split(/\r?\n/).map((l) => l.trim()).filter(Boolean); for (let i = arr.length - 1; i > 0; i--) { const j = rnd(i + 1);[arr[i], arr[j]] = [arr[j], arr[i]]; } listInput.value = arr.join("\n"); }, "rv-tbtn"));

	// uuid
	const uuidOut = named(input("text", { readOnly: true }), "Generated UUID"); uuidOut.classList.add("rv-pass-out");
	const uuidRow = el("div", "rv-trow");
	uuidRow.append(uuidOut, btn("Generate", () => { uuidOut.value = (crypto.randomUUID ? crypto.randomUUID() : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => { const r = rnd(16); return (c === "x" ? r : (r & 0x3) | 0x8).toString(16); })); }, "rv-tbtn rv-tbtn-accent"), btn("Copy", () => copy(uuidOut.value), "rv-tbtn"));

	s.append(
		mk("Dice", diceRow, diceOut),
		mk("Coin", coinRow, coinOut),
		mk("Number", numRow, numOut),
		mk("List picker", pickRow, pickOut, listInput),
		mk("UUID", uuidRow),
	);
	function mk(title, controls, out, extra) { const b = el("div", "rv-rand-block"); b.append(el("h2", "rv-tool-sub", title)); if (extra) b.append(extra); b.append(controls); if (out) b.append(out); return b; }
}
